var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBgcolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Delete"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    clipPath: "url(#clip-Delete)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash-alt-regular",
    d: "M13.086,20.312h1.172a.586.586,0,0,0,.586-.586V9.18a.586.586,0,0,0-.586-.586H13.086a.586.586,0,0,0-.586.586V19.727A.586.586,0,0,0,13.086,20.312ZM21.094,3.906H17.07L15.41,1.138A2.344,2.344,0,0,0,13.4,0H8.476a2.344,2.344,0,0,0-2.01,1.138L4.805,3.906H.781A.781.781,0,0,0,0,4.687v.781a.781.781,0,0,0,.781.781h.781V22.656A2.344,2.344,0,0,0,3.906,25H17.969a2.344,2.344,0,0,0,2.344-2.344V6.25h.781a.781.781,0,0,0,.781-.781V4.687A.781.781,0,0,0,21.094,3.906Zm-12.7-1.42a.293.293,0,0,1,.252-.142h4.59a.293.293,0,0,1,.251.142l.853,1.42h-6.8Zm9.578,20.17H3.906V6.25H17.969ZM7.617,20.312H8.789a.586.586,0,0,0,.586-.586V9.18a.586.586,0,0,0-.586-.586H7.617a.586.586,0,0,0-.586.586V19.727A.586.586,0,0,0,7.617,20.312Z",
    transform: "translate(0.062)",
    fill: "#a6a7ad"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBgcolor);
export default __webpack_public_path__ + "static/media/delete-bgcolor.7b094335.svg";
export { ForwardRef as ReactComponent };